import axios, { AxiosRequestConfig } from 'axios'
import { Options } from '../actions/dx-training/types'
import { bffOpts } from './config'

export const completeTrainingCourse = async (options: Options) => {
  const { courseId, token } = options
  const url = `/v1/training/${courseId}/completed/`

  const config: AxiosRequestConfig = {
    ...bffOpts
  }
  config.headers.Authorization = token

  const instance = axios.create(config)

  const res = await instance.post(url, {})
  return res
}
